import { Component, OnInit, ViewChild} from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import {ApproverServicesDetailComponent} from '../approver-services-detail/approver-services-detail.component';
import * as decode from 'jwt-decode';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-services-list',
  templateUrl: './services-list.component.html',
  styleUrls: ['./services-list.component.scss']
})
export class ServicesListComponent implements OnInit {
  userId: any;
  userToken: any;
  listOrders: any = [];
  temp: any = [];
  load = true;
  viewPage = 1;
  txtHead = 'Pendientes de aprobar';
  profileId: any;
  expanded: any = {};
  @ViewChild('table', { static: false }) table: any;
  
  providersList=[];
  data: any = {};
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  providerActive = 'hide';
  isExternal;
  perfilId;
  arrOc = [];


  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  loadBtn = false;
  listSocieties = [];

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.profileId = tokenPayload.IdPerfil;
    this.userId = tokenPayload.Id;
    gralService.changeTextHead('SERVICES');

    //this.getPendings();
    this.getSocieties();

    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;
    this.providerActive = (this.perfilId == '3' && this.isExternal )? 'hide': 'show';
    
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

      this.data.FechaFin = new Date();
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }
  
  addProveedorSearch(option){
    console.log('option', option);
    let value = this.myControl.value;
    if ((value || '').trim()) {
      let proveedor = value.split(' - ');      
      this.arrOc.push(proveedor[0]);
    }

    this.myControl.setValue('');
  }

  search(){
    
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  disabledProv(){
    let resp = false;
    
    if(this.data.Sociedad){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
      if(society.NumProveedor){
        resp = true;
        
      }
    }
    return resp;
  }

  getPendings(){
    this.provService.searchOrdersService(this.userId, this.userToken).then((data) => {
      this.load = false;
      this.listOrders = data;
      this.temp = data;
    }, (err) => {
      console.log(err);
      this.listOrders = null;
      this.temp = null;
      this.load = false;
      this.toastr.error('--', 'Error');// ver como esta url regresa los errores
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  getHistory(){
    this.provService.historyOrdersService(this.userToken).then((data) => {
      this.load = false;
      this.listOrders = data;
      this.temp = data;
    }, (err) => {
      console.log(err);
      this.listOrders = null;
      this.temp = null;
      this.load = false;
      this.toastr.error('--', 'Error');// ver como esta url regresa los errores
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  page(type){
    if(type == 2){
      this.txtHead = 'Histórico de ordenes de compra de servicios';
      this.load = true;
      this.getHistory();
      this.viewPage = 2;
    }

    if(type == 1){
      this.txtHead = 'Pendientes de aprobar';
      this.load = true;
      this.getPendings();
      this.viewPage = 1;
    }

  }

  detail(idx, type){
    console.log('detail', this.listOrders[idx].lsPOCargadaItemViewModel);
    const dialogRef = this.dialog.open(ApproverServicesDetailComponent, {
      minWidth: '80%',
      position: {
        top: '6%'
      },
      data: { type: 'detailOc', view: type, id: this.listOrders[idx].idFactura, order: this.listOrders[idx].ordenCompra, items: this.listOrders[idx].lsPOCargadaItemViewModel}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){

      }
    });
  }

  approve(idx){
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'active', id: null, button: 'Aprobar', title: 'Aprobar servicio', content: '¿Esta seguro de aprobar este servicio?', icon: 'warning' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.provService.apporveService(this.listOrders[idx].idFactura, this.listOrders[idx].ordenCompra, this.userToken).then((data) => {
          this.toastr.success('Servicio aprobado correctamente', 'Aprobar servicio');
          this.listOrders.splice(idx, 1);
          console.log(data);
        }, (err) => {
          console.log(err);
          this.toastr.error('--', 'Error');// ver como esta url regresa los errores
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }
    });
  }

  reject(idx){
    const id = this.listOrders[idx].idFactura;
    const oc = this.listOrders[idx].ordenCompra;

    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'delete', id: null, comments: true, button: 'Continuar', title: 'Rechazar servicio', content: '¿Esta seguro de rechazar la orden de compra <strong>'+this.listOrders[idx].ordenCompra+'</strong>?<br><small>Si es así, escribe un "porque" y de click en continuar.</small>', icon: 'warning' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.provService.rejectService(this.listOrders[idx].idFactura, result.comments, this.userToken).then((data) => {
          this.toastr.success('Orden de compra rechazada correctamente', 'Rechazar orden de compra');
          this.listOrders.splice(idx, 1);
        }, (err) => {
          console.log(err);
          this.toastr.error('--', 'Error');// ver como esta url regresa los errores
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
        this.listOrders.splice(idx, 1);
      }
    });
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listOrders);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('servicio_lista'));
  }

  updateFilter(event){
    const val = event.target.value.toLowerCase();
     
    const temp = this.temp.filter(function(d) {      
      let ret = d.ordenCompra.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.folio.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.idFactura.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.fechaOperacion.toLowerCase().indexOf(val) !== -1 || !val;
      return ret;
    });

    this.listOrders = temp;
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.data.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety(0);
          
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(pos){
    if(this.perfilId==3){
      let List = this.listSocieties;
      this.arrOc = [];      
      this.arrOc.push(List[pos].NumProveedor);
    }
  }

}
